import {css} from "@emotion/css";
import {Skeleton} from "@mui/material";
import React from "react";
import {RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";

export default function MediaItemShimmer() {
    return (
        <RaikoGridOneColumn className={css`gap: .5rem`}>
            {
                [...Array(5)].map((item, index) => {
                    return <Skeleton variant={"rounded"} className={css`padding: 44px;border-radius: 15px !important`}/>
                })
            }
        </RaikoGridOneColumn>
    )
}